/**
 * @flow
 * @relayHash 660c4996f1aba47af8f3363c1fa25f3e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type orderList_viewer$ref = any;
export type orderList_QueryVariables = {| |};
export type orderList_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: orderList_viewer$ref,
  |},
|};
*/


/*
query orderList_Query {
  viewer {
    ...orderList_viewer
    id
  }
}

fragment orderList_viewer on Viewer {
  my_orders {
    id
    currency_code
    currency_rate
    invoice_number
    order_date
    payment_due_date
    payment_status
    total
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "orderList_Query",
  "id": null,
  "text": "query orderList_Query {\n  viewer {\n    ...orderList_viewer\n    id\n  }\n}\n\nfragment orderList_viewer on Viewer {\n  my_orders {\n    id\n    currency_code\n    currency_rate\n    invoice_number\n    order_date\n    payment_due_date\n    payment_status\n    total\n    project_details {\n      brand\n      product\n      reference\n      po_number\n      notes\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "orderList_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "orderList_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "orderList_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "my_orders",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": true,
            "selections": [
              v0,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "currency_code",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "currency_rate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "invoice_number",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "order_date",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "payment_due_date",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "payment_status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "project_details",
                "storageKey": null,
                "args": null,
                "concreteType": "ProjectDetails",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "brand",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "product",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "reference",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "po_number",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '81c0c6aa1deec5c6cc0baa75fcf89c6e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/orderList_Query.graphql.js